
import {
  MDBCol,
  MDBRow,
  MDBContainer
} from 'mdb-react-ui-kit';

export default function Section1() {




  return (
    <MDBContainer fluid style={{ backgroundColor: "rgba(48, 62, 96, 1)" }} >
      <MDBRow className="align-items-center">
        {/* Image à gauche */}
        <MDBCol md="5" className="text-center">
          <img
            src="/projet.png"  
            alt="Présentation"
            style={{ marginTop: '5%', 
              marginBottom: '5%', 
              width: "100%", 
              maxWidth: "400px", 
              border: "2px solid #F2A541", 
              borderRadius: '10px',
              boxShadow: "10px 10px 100px rgba(0, 0, 0, 0.5)" }}
          />
        </MDBCol>


        {/* Texte à droite */}
        <MDBCol md="6">
          <div id='projet' style={{
                  display: 'flex', // Utilise flexbox pour aligner horizontalement
                  alignItems: 'center', // Centre verticalement le contenu
                  gap: '10%', // Espacement entre la barre et le texte
                  minHeight: '200px',  // Assure-toi que le parent a une hauteur
                  scrollMarginTop: '120px'
                }}>
            <div style={{
              width: '7px',  // Largeur de la barre verticale
              height: '250px',  // Hauteur de la barre
              backgroundColor: '#F2A541'
            }}></div>
            <div>
              <h2 style={{ fontFamily: "Consolas, monospace", color: "#F2A541" }}>Le Projet</h2>
              <p style={{ fontFamily: "Consolas, monospace", fontSize: "16px", lineHeight: "1.5", color: "#ffffff", textAlign: "justify" }}>
              Notre but est de participer à la course Les Sables - Les Açores - Les Sables : 20 jours de mer pour parcourir 2600 milles entre la France et Horta en solitaire chacun sur son bateau sans assistance ni communication sur des voiliers de 6m50. Le départ est en juillet 2026. <br /><br />
Pour en arriver là, un programme de deux ans de préparation a démarré : entraînements et formations au pôle de Concarneau, entretien des bateaux, et des courses qualificatives ! Nous participerons tous les deux à plus de cinq courses par an qui nous emmèneront des côtes bretonnes à la Vendée, de la Normandie au sud de l’Irlande en passant par l’Angleterre.

              </p>
            </div>
          </div>
        </MDBCol>
      </MDBRow>


      <MDBRow className="align-items-center">
        {/* Image à gauche */}
        <MDBCol md="5" className="text-center">
          <img
            src="/sh_team_.png"  
            alt="Equipe"
            style={{ marginTop: '5%', 
              marginBottom: '5%', 
              width: "100%", 
              maxWidth: "400px", 
              border: "2px solid #F2A541", 
              borderRadius: '10px',
              boxShadow: "10px 10px 100px rgba(0, 0, 0, 0.5)" }}
          />
        </MDBCol>

        {/* Texte à droite */}
        <MDBCol md="6">
          <div id='equipe' style={{
                  display: 'flex', // Utilise flexbox pour aligner horizontalement
                  alignItems: 'center', // Centre verticalement le contenu
                  gap: '10%', // Espacement entre la barre et le texte
                  minHeight: '200px',  // Assure-toi que le parent a une hauteur
                  scrollMarginTop: '180px'
                }}>
            <div style={{
              width: '6px',  // Largeur de la barre verticale
              height: '270px',  // Hauteur de la barre
              backgroundColor: '#F2A541'
            }}></div>
            <div>
              <h2 style={{ fontFamily: "Consolas, monospace", color: "#F2A541" }}>L'Equipe</h2>
              <p style={{ fontFamily: "Consolas, monospace", fontSize: "16px", lineHeight: "1.5", color: "#ffffff", textAlign: "justify" }}>
              Nous sommes Sébastien et Hugues, 26 et 27 ans, deux amis de l'école d’ingénieur des Ponts et Chaussées, réunis par un même rêve : la course au large. <br /><br />
En 2024, nous décidons de franchir un cap en nous lançant un défi unique et ambitieux : celui de courir côte à côte sur deux bateaux identiques, en équipe, avec comme objectif de se soutenir pour progresser ensemble.

              </p>
            </div>
          </div>
        </MDBCol>
      </MDBRow>



      <MDBRow className="align-items-center">
        {/* Image à gauche */}
        <MDBCol md="5" className="text-center">
          <img
            src="/programme.png" 
            alt="Présentation"
            style={{ marginTop: '5%', 
              marginBottom: '5%', 
              width: "100%", 
              maxWidth: "400px", 
              border: "2px solid #F2A541", 
              borderRadius: '10px',
              boxShadow: "10px 10px 100px rgba(0, 0, 0, 0.5)" }}
          />
        </MDBCol>

        {/* Texte à droite */}
        <MDBCol md="6">
          <div id='programme' style={{
                  display: 'flex', // Utilise flexbox pour aligner horizontalement
                  alignItems: 'center', // Centre verticalement le contenu
                  gap: '10%', // Espacement entre la barre et le texte
                  minHeight: '200px',  // Assure-toi que le parent a une hauteur
                  scrollMarginTop: '120px'
                }}>
            <div style={{
              width: '4px',  // Largeur de la barre verticale
              height: '270px',  // Hauteur de la barre
              backgroundColor: '#F2A541'
            }}></div>
            <div>
              <h2 style={{ fontFamily: "Consolas, monospace", color: "#F2A541" }}>Le Programme</h2>
              <p style={{ fontFamily: "Consolas, monospace", fontSize: "16px", lineHeight: "1.5", color: "#ffffff" }}>
                En 2025, 6 courses au programme : 
              </p>
              <ul style={{ fontFamily: "Consolas, monospace", fontSize: "14px", lineHeight: "1.5", color: "#ffffff" }}>
                <li>10 Avril : Plastimo Lorient Mini, 250 milles en double au départ et à l'arrivée de Lorient</li>
                <li>18 Avril : Spi Ouest France, régates à la journée en double à La Trinité sur Mer </li>
                <li>19 Mai : Mini en Mai, 500 milles en solitaire au départ et à l'arrivée de La Trinité sur Mer</li>
                <li>15 Juin : Mini Fastnet, 600 milles en double entre le phare du Fastnet en Irlande et Douarnenez</li>
                <li>28 Juin : Calvados Cup n°1, Douarnenez - Deaville en double</li>
                <li>4 Juillet : Calvados Cup n°2, 500 milles en Solitaire au départ et à l'arrivée de Deauville</li>
              </ul>
              <p style={{ fontFamily: "Consolas, monospace", fontSize: "16px", lineHeight: "1.5", color: "#ffffff" }}>
                En 2026, on repart sur une saison de courses jusqu'à l'objectif de la course Les Sables - Les Açores - Les Sables en juillet !
              </p>
            </div>
          </div>
        </MDBCol>
      </MDBRow>

      <MDBRow className="align-items-center">
        {/* Image à gauche */}
        <MDBCol md="5" className="text-center">
          <img
            src="/bateaux.png" 
            alt="Présentation"
            style={{ marginTop: '5%', 
              marginBottom: '5%', 
              width: "100%", 
              maxWidth: "400px", 
              border: "2px solid #F2A541", 
              borderRadius: '10px',
              boxShadow: "10px 10px 100px rgba(0, 0, 0, 0.5)" }}
          />
        </MDBCol>

        {/* Texte à droite */}
        <MDBCol md="6">
          <div id='bateaux' style={{
                  display: 'flex', // Utilise flexbox pour aligner horizontalement
                  alignItems: 'center', // Centre verticalement le contenu
                  gap: '10%', // Espacement entre la barre et le texte
                  minHeight: '200px',  // Assure-toi que le parent a une hauteur
                  scrollMarginTop: '180px'
                }}>
            <div style={{
              width: '6px',  // Largeur de la barre verticale
              height: '270px',  // Hauteur de la barre
              backgroundColor: '#F2A541'
            }}></div>
            <div>
              <h2 style={{ fontFamily: "Consolas, monospace", color: "#F2A541" }}>Les Bateaux</h2>
              <p style={{ fontFamily: "Consolas, monospace", fontSize: "16px", lineHeight: "1.5", color: "#ffffff", textAlign: "justify" }}>
                Les mini 6.50 sont les plus petits bateaux de course au large. Bon nombre de grands marins ont commencé sur ce circuit.
                Exigeants, légers, rapides, c'est un support génial pour appréhender les courses de plusieurs jours. <br />
                Nous avons opté pour deux Vectors, un des derniers modèles de mini conçus. Une particularité : leur étrave ronde. Bien qu'intrigante, elle permet des surfs sensationnels au portant (quand le vent vient de derrière) dans les vagues.
              </p>
            </div>
          </div>
        </MDBCol>
      </MDBRow>


      







    </MDBContainer>
    
      
  );
}